import {
    Flex,
    Stack,
    useColorModeValue,
    Button,
    Text,
    //Image,
    Box,
    // Skeleton,
    // SkeletonCircle,
} from '@chakra-ui/react';
import EarnedPointHistory from '../../components/UserComponents/EarnedPointHistory';
import UsedPointHistory from '../../components/UserComponents/UsedPointHistory';
import ExpiredPointHistory from '../../components/UserComponents/ExpiredPointHistory';
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"; 
import { 
  useFetchUserPointTransactionsMutation, 
  //useGetUserDataMutation, 
} from '../../slices/userApiSlice';
import MonthYearPicker from '../../components/UserComponents/MonthYearPicker';
import Loader from '../../components/Loader';
import { useTranslation } from 'react-i18next';
import dateUtils from '../../utils/formatDate';

const UserPointScreen = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [fetchUserTransactions] = useFetchUserPointTransactionsMutation();
    const [fetchUserPointsHistory, setfetchUserPointsHistory] = useState([]);
    const [pointsTransactionLoading, setPointsTransactionLoading] = useState(false);

    // const [getUserData] = useGetUserDataMutation();
    //const [userData, setUserData] = useState(null);

    // Earned Point History Component color
    const earnedPointsHistoryBgColor = useColorModeValue('custom.900', 'gray.700');
    const earnedPointsHistoryIconColor = useColorModeValue('green.500', 'green.300');
    const earnedPointsTextColor = useColorModeValue('custom.800', 'gray.200');

    // Expired Point History Component color
    const expiredPointsHistoryBgColor = useColorModeValue('custom.900', 'gray.700');
    const expiredPointsHistoryIconColor = useColorModeValue('red.500', 'red.300');
    const expiredPointsTextColor = useColorModeValue('custom.800', 'gray.200');

    // Used Point History Component color
    const usedPointsHistoryBgColor = useColorModeValue('custom.900', 'gray.700');
    const usedPointsHistoryIconColor = useColorModeValue('blue.500', 'blue.300');
    const usedPointsTextColor = useColorModeValue('custom.800', 'gray.200');

    const bgColor = useColorModeValue('teal.600', 'gray.800');
    const bgColorDark = useColorModeValue('gray.50', 'gray.700');
    const textColor = useColorModeValue('custom.900', 'gray.200');
   
    const selectedButtonColor = useColorModeValue('custom.800', 'teal.200');
    const navBgColor = useColorModeValue('custom.900', 'gray.800');

    const [view, setView] = useState('earned');
    // const [loading, setLoading] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const selectedButtonBgColor = useColorModeValue('teal.500', 'teal.300');

    const { t } = useTranslation();
    const savedLanguage = localStorage.getItem("i18nextLng") || "en";

    // const fetchData = useCallback(async () => {
    //   setLoading(true);
    //   try {
    //     const userResponse = await getUserData(id).unwrap();
    //     setUserData(userResponse.user);
    //   } catch(err) {
    //       // console.error('Error fetching user data:', err);
    //   } finally {
    //     setLoading(false);
    //   }
    // }, [id, getUserData]);

    const fetchPointTransactions = useCallback(async () => {
      if (!id || !selectedMonth || !selectedYear) {
        return;
      }
    
      setPointsTransactionLoading(true);
      try {
        const userPointsResponse = await fetchUserTransactions({
          id,
          selectedMonth,
          selectedYear,
        }).unwrap();
    
        // Safely set transactions (fallback to empty array if undefined)
        setfetchUserPointsHistory(userPointsResponse?.transactions || []);
    
      } catch (err) {
        // console.error('Error fetching points history:', err);
        // Optionally, set an error state or show a notification to the user
      } finally {
        setPointsTransactionLoading(false);
      }
    }, [id, selectedMonth, selectedYear, fetchUserTransactions, setPointsTransactionLoading]);
  
    useEffect(() => {
      // fetchData();
      fetchPointTransactions();
    }, [fetchPointTransactions]);

    const getFilteredTransactions = (type) => {
      return fetchUserPointsHistory.filter(transaction => transaction.type === type);
    };
    
    const renderTransactionView = () => {
      switch (view) {
        case 'earned':
          const earnedTransactions = getFilteredTransactions('earn');
          return earnedTransactions.length > 0 ? (
            <EarnedPointHistory 
              earnPointsTransactions={earnedTransactions} 
              isLoading={pointsTransactionLoading} 
              Loader={<Loader minH={'50vh'} />}
              bgColor={earnedPointsHistoryBgColor}
              textColor={earnedPointsTextColor}
              iconColor={earnedPointsHistoryIconColor}
            />
          ) : <Text fontSize={'sm'} textAlign='center' color="gray.500">
                {t('no_data_with_date', { 
                  date: dateUtils.formatDateDisplay(selectedYear, selectedMonth, savedLanguage)
                })}
              </Text>
    
        case 'used':
          const usedTransactions = getFilteredTransactions('redeem');
          return usedTransactions.length > 0 ? (
            <UsedPointHistory 
              usedPointsTransactions={usedTransactions} 
              isLoading={pointsTransactionLoading} 
              Loader={<Loader minH={'50vh'} />}
              bgColor={usedPointsHistoryBgColor}
              textColor={usedPointsTextColor}
              iconColor={usedPointsHistoryIconColor}
            />
          ) : <Text fontSize={'sm'} textAlign='center' color="gray.500">
                {t('no_data_with_date', { 
                  date: dateUtils.formatDateDisplay(selectedYear, selectedMonth, savedLanguage)
                })}
              </Text>
        
        case 'expired':
        const expiredTransactions = getFilteredTransactions('expired');
        return expiredTransactions.length > 0 ? (
          <ExpiredPointHistory 
            expiredPointsTransactions={expiredTransactions} 
            isLoading={pointsTransactionLoading} 
            Loader={<Loader color={usedPointsTextColor} minH={'50vh'} />}
            bgColor={expiredPointsHistoryBgColor}
            textColor={expiredPointsTextColor}
            iconColor={expiredPointsHistoryIconColor}
          />
        ) : <Text fontSize={'sm'} textAlign='center' color="gray.500">
              {t('no_data_with_date', { 
                date: dateUtils.formatDateDisplay(selectedYear, selectedMonth, savedLanguage)
              })}
            </Text>
            
        default:
          return ;
    
      }
    };

    const handleDateChange = (month, year) => {
      setSelectedMonth(month);
      setSelectedYear(year);
    };

    return (
      <Flex
        direction="column"
        align="center"
        bg={bgColor}
        color={textColor}
        minH="100vh"
        w="100%"
        pt={`calc(1rem + env(safe-area-inset-top))`}
      >
        {/* Header */}
        <Box
          display="flex"
          alignItems="center"
          w="100%"
          p={3}
          mb={4}
          bg={bgColor}
        >
          <FontAwesomeIcon
            icon={faArrowLeft}
            size="xl"
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer', marginRight: '8px' }}
          />
          <Text fontSize="xl" fontWeight="bold">
            {t('points_history.title')}
          </Text>
        </Box>

        {/* Main Container */}
        <Stack
          w="full"
          maxW="lg"
          bg={bgColorDark}
          p={4}
          spacing={6}
          borderRadius="2xl"
          position="relative"
          flexGrow={1}
        >
          {/* Filter Buttons */}
          <Stack
            direction="row"
            spacing={3}
            bg={navBgColor}
            p={1}
            rounded="full"
            boxShadow="md"
            w="full"
            mt={2}
          >
            {['earned', 'used', 'expired'].map((type) => (
              <Button
                key={type}
                w="full"
                rounded="full"
                fontSize="sm"
                onClick={() => setView(type)}
                bg={view === type ? selectedButtonBgColor : navBgColor}
                color={view === type ? navBgColor : selectedButtonColor}
                _hover={{ color: 'white', bg: 'teal.500' }}
              >
                {t(`points_history.${type}`)}
              </Button>
            ))}
          </Stack>

          {/* Date Picker */}
          <Box color={selectedButtonColor}>
            <MonthYearPicker onChange={handleDateChange} language={savedLanguage} />
          </Box>

          {/* Transactions Content */}
          {renderTransactionView()}
        </Stack>
      </Flex>

    );
}

export default UserPointScreen;